import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createFolder, deleteFolder, getFolders, updateFolder } from '../../actions'
import styles from './SubjectCategories.module.scss'
import i18n from '../../../../lib/i18n'
import { SlArrowDown, SlArrowUp } from 'react-icons/sl'
import { AiOutlinePlus, AiOutlineMinus, AiOutlineEdit } from 'react-icons/ai'
import FormData from './components/FormData/FormData'
import classNames from 'classnames'
import { Button, Modal, Popconfirm, message } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons';
import { change, reset } from 'redux-form'
import SubjectItemCategories from './components/SubjectItemCategories/SubjectItemCategories'
const { confirm } = Modal;

function SubjectCategories() {
  const [messageApi, contextHolder] = message.useMessage();
  const [show, setShow] = useState(false)
  const [active, setActive] = useState(true)
  const [loaded, setLoaded] = useState(true)
  const [item, setItem] = useState({})
  const list = useSelector(state => state.slider.folders);

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getFolders())
    // dispatch(getCategories())
  }, [])

  const onSave = async (formValues) => {
    const values = { ...formValues, title: String(formValues.title || '').trim() }
    try {
      if (values.id) {
        await dispatch(updateFolder(values));
        messageApi.open({
          type: 'success',
          content: i18n('qn_sb_msg_updated'),
        });
        setShow(false)
      } else {
        await dispatch(createFolder(values));
        messageApi.open({
          type: 'success',
          content: i18n('qn_sb_msg_created'),
        });
        confirm({
          autoFocusButton: null,
          title: i18n('qn_sb_title_confirn'),
          icon: <ExclamationCircleFilled />,
          content: i18n('qn_sb_msg_confirn'),
          onOk() {
            dispatch(reset('subject_folder'))
          },
          onCancel() {
            dispatch(reset('subject_folder'))
            setShow(false)
          },
        });
      }
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: i18n('qn_sb_msg_error'),
      });
    }
  }


  return (
    <div className={styles.SubjectCategories}>
      {contextHolder}
      <FormData
        open={show}
        onClose={() => setShow(false)}
        initialValues={item}
        onSave={onSave}
        loaded={loaded}
      />
      <div className={styles.header}>
        <div className={styles.title}>{i18n('qn_subjects_category')}</div>
        <div className={styles.action}>
          <Button size='small' type='primary' onClick={() => {
            setShow(true)
            setItem({})
          }}>{i18n('sc_new')}</Button>
        </div>
      </div>
      {active && <>
        <div className={styles.body}>
          <div className={styles.items}>
            {list.map(_i =>
              <SubjectItemCategories
                onDeleteItem={() => {
                  Modal.confirm({
                    autoFocusButton: null,
                    title: i18n('qn_sb_title_delete'),
                    content: i18n('qn_sb_msg_delete'),
                    okText: i18n("Yes"),
                    cancelText: i18n("No"),
                    onOk: () => {
                      dispatch(deleteFolder(_i.id))
                    }
                  });
                }}
                setUpdateItem={() => {
                  setShow(true)
                  setItem(_i)
                }}
                subject={_i} key={'subject_' + _i.id}
              />
            )}
          </div>
        </div>
      </>}
    </div>
  )
}

export default SubjectCategories